<template >
<div class="tableTitle" :class="isFlex?'flex':''">
  <div class="icon ">
    <span :class="icon" v-if='icon'></span>
    <span>{{title}}</span>
    <slot name="describe">
      <span class="proposal" v-if='describe'>{{describe}}</span>
    </slot>
  </div>
  <slot></slot>
</div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    describe: {
      type: String
    },
    icon: {
      type: String
    },
    isFlex: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.tableTitle {
    padding: 10px;
    .icon {
        min-height: 10px;
        padding: 10px 0;
        display: flex;
        align-items: center;
        flex: 1;
        font-size: 14px;
        color: #606266;
        > span {
            padding-right: 10px;
            display: flex;
        }
    }
}
.flex {
    display: flex;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/tableHeader/index.vue